import { H1 } from '../Typography'

const HeaderSession = ({ text, ...rest }) => <H1 {...rest}>{text}</H1>

export default HeaderSession
